class MyprideDrawer extends HTMLElement {
  constructor() {
    super();
    this.burger = this.querySelector('.mypride-drawer__burger');
    this.panel = this.querySelector('.mypride-drawer__panel');
    this.close = this.querySelector('.mypride-drawer__close');
    this.navWrap = this.querySelector('.mypride-drawer__nav-wrap');
    this.activeSub = null;
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  connectedCallback() {
    if (!this.burger || !this.panel) return;
    this.burger.addEventListener('click', this.open.bind(this));
    this.close.addEventListener('click', this.closeDrawer.bind(this));
    this.querySelectorAll('.mypride-drawer__nav a').forEach((link) => {
      link.addEventListener('click', this.closeDrawer.bind(this));
    });
    this.querySelectorAll('.mypride-drawer__sub-list a').forEach((link) => {
      link.addEventListener('click', this.closeDrawer.bind(this));
    });

    this.querySelectorAll('.mypride-drawer__sub-trigger').forEach((btn) => {
      btn.addEventListener('click', () => this.openSubMenu(btn));
    });
    this.querySelectorAll('.mypride-drawer__back').forEach((btn) => {
      btn.addEventListener('click', this.closeSubMenu.bind(this));
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  open() {
    this.panel.classList.add('is-open');
    this.panel.setAttribute('aria-hidden', 'false');
    this.burger.setAttribute('aria-expanded', 'true');
    this.close.setAttribute('aria-expanded', 'true');
    this.resetToRoot();
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this.onKeyDown);
    this.close.focus();
  }

  closeDrawer() {
    this.panel.classList.remove('is-open');
    this.panel.setAttribute('aria-hidden', 'true');
    this.burger.setAttribute('aria-expanded', 'false');
    this.close.setAttribute('aria-expanded', 'false');
    this.resetToRoot();
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this.onKeyDown);
  }

  openSubMenu(btn) {
    const targetId = btn.dataset.subPanel;
    const target = targetId ? this.querySelector(`#${targetId}`) : null;
    if (!target) return;

    this.closeSubMenu();
    target.classList.add('is-active');
    this.activeSub = target;
    if (this.navWrap) this.navWrap.classList.add('has-subopen');
    btn.setAttribute('aria-expanded', 'true');
  }

  closeSubMenu() {
    if (this.activeSub) {
      this.activeSub.classList.remove('is-active');
      this.activeSub = null;
    }
    if (this.navWrap) this.navWrap.classList.remove('has-subopen');
    this.querySelectorAll('.mypride-drawer__sub-trigger').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  resetToRoot() {
    this.closeSubMenu();
  }

  onKeyDown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      if (this.activeSub) {
        this.closeSubMenu();
      } else {
        this.closeDrawer();
        this.burger.focus();
      }
    }
  }
}

customElements.define('mypride-drawer', MyprideDrawer);
